import events from '../../actions/event-names';
import Config from '../../config';
import { showError, showSuccess } from '../../utils';
import _ from 'lodash';

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    trophySettingsList: [],
    isDetailsFetched: false,
    trainingModuleDetails: "",
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    // TROPHY SETTINGS LIST
    case `${events.GET_TROPHY_SETTINGS_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.trophySettingsList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_TROPHY_SETTINGS_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            trophySettingsList: [...state.trophySettingsList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_TROPHY_SETTINGS_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    // GET TROPHY SETTINGS DETAILS DETAILS
    case `${events.GET_TROPHY_SETTINGS_DETAILS}_PENDING`: {
        return {
            ...state,
            trophySettingseDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_TROPHY_SETTINGS_DETAILS}_FULFILLED`: {
        return {
            ...state,
            trophySettingseDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_TROPHY_SETTINGS_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    // UPDATE TROPHY SETTINGS DETAILS DETAILS
    case `${events.SAVE_TROPHY_SETTINGS_DETAILS}_PENDING`: {
        return {
            ...state,
            isUpdateTrophy: 'PENDING',
        };
    }
    case `${events.SAVE_TROPHY_SETTINGS_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isUpdateTrophy: 'FULFILLED',
        };
    }
    case `${events.SAVE_TROPHY_SETTINGS_DETAILS}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isUpdateTrophy: 'REJECTED',
        };
    }


    

    default:
        return state;
    }
}
